import { registerPlugin } from "@capacitor/core";

/**
 * @carata/capacitor-voice-call
 * ---------------------------------------------------------------------
 * Registers the native VoiceCall plugin. See ios/Sources/VoiceCallPlugin
 * and android/.../VoiceCallPlugin.kt for the actual implementations, and
 * this package's README for the full method/event contract.
 *
 * The web implementation (./web.js) is deliberately a stub that reports
 * unsupported - src/classes/VoiceOrderCallClient.js in the main app
 * never calls into this plugin unless Capacitor.isNativePlatform() is
 * true, so the web stub existing at all is just Capacitor plugin
 * hygiene (every platform needs *some* implementation registered), not
 * a real fallback path.
 */
const VoiceCall = registerPlugin("VoiceCall", {
    web: () => import("./web.js").then((m) => new m.VoiceCallWeb()),
});

export * from "./definitions.js";
export { VoiceCall };
